/** Build-time editions share gameplay code but own their workload and preferences. */
export const IS_LITE = import.meta.env.MODE === 'lite';
export const EDITION = IS_LITE ? 'lite' : 'normal';
export const GAME_NAME = IS_LITE ? 'Lite BlockSandbox' : 'BlockSandbox';
export const WORKLOAD = {
  fragmentCells: IS_LITE ? 480 : 240,
  collapseCells: IS_LITE ? 1800 : 960,
  secondaryMinimum: IS_LITE ? 64 : 24,
  pedestrianHz: IS_LITE ? 15 : 30,
  trafficHz: IS_LITE ? 20 : 30,
} as const;
